import { Ebbne, MountWithEbbne, useEbbne, useEbbnenContext } from "@solidwhite/ebbnen";
import Section from "../Section";
import RoundedPlaneGeometry from "../RoundedPlaneGeometry";
import SubSection from "../SubSection";
import { Suspense } from "react";
import LoadingCallback from "../../LoadingCallback";
import { HardlineWrapper } from "./hardline/Hardline";
import Weldac from "./weldac/Weldac";
import Sinac from "./sinac/Sinac";
import Minac from "./minac/Minac";
import { SideBarHider } from "../../ui/SideBar/SideBar";
import VisibleWithEbbne from "../VisibleWithEbbne";
import useHashLocation from "../../../use-hash-location";
import { Vector3 } from "three";

const HeatingProducts = ({ nodes, ...props }) => {
  const [_loc, setLocation] = useHashLocation();

  return (
    <Ebbne id="products">
      <MountWithEbbne>
        <SideBarHider />
      </MountWithEbbne>

      <group position={nodes.products.position} rotation={nodes.products.rotation}>
        <Section object3d={nodes.products} />
        <MountWithEbbne mountedWhen={"visible"}>
          <RoundedPlaneGeometry
            radius={0.1}
            lenght={10.94342}
            width={8.143605}
            height={40}
            curveSegments={32}
            position={[0.83, 0, -0.43]}
          />
        </MountWithEbbne>
      </group>

      <Ebbne id="sinac" visibleWithAbove={2}>
        <group position={nodes.products.position} rotation={nodes.products.rotation}>
          <SubSection object3d={nodes.sinac} isProductSection hideModel={true} />
        </group>

        <VisibleWithEbbne visibleWhen="visible-and-below">
          <Sinac />
        </VisibleWithEbbne>

        {/* <MountWithEbbne mountedWhen={"visible-and-below"}>
          <Suspense fallback={<LoadingCallback />}></Suspense>
        </MountWithEbbne> */}
      </Ebbne>

      <Ebbne id="weldac" visibleWithAbove={2} visibleWithBelow={1}>
        <group position={nodes.products.position} rotation={nodes.products.rotation} visible={true}>
          <SubSection object3d={nodes.weldac} isProductSection hideModel={true} />
        </group>

        <VisibleWithEbbne visibleWhen="visible-and-below">
          <Weldac />
        </VisibleWithEbbne>

        <VisibleWithEbbne visibleWhen={"visible"} hideWhenBelow>
          <group position={nodes.products.position} rotation={nodes.products.rotation}>
            <group position={nodes.weldac.position} rotation={nodes.weldac.rotation}>
              <primitive object={nodes["Weldac_Environment"]} />
            </group>
          </group>
        </VisibleWithEbbne>
      </Ebbne>

      <Ebbne id="minac" visibleWithAbove={2}>
        <group position={nodes.products.position} rotation={nodes.products.rotation}>
          <SubSection
            object3d={nodes.minac}
            isProductSection
            // hideModel={false}
            hideWhenActive={true}
          />
        </group>

        <VisibleWithEbbne visibleWhen="visible-and-below">
          <Minac />
        </VisibleWithEbbne>

        {/* <MountWithEbbne mountedWhen={"visible-and-below"}>
          <Suspense fallback={<LoadingCallback />}>
            <Minac />
          </Suspense>
        </MountWithEbbne> */}
      </Ebbne>

      <Ebbne id="hardline" visibleWithAbove={2}>
        <group position={nodes.products.position} rotation={nodes.products.rotation}>
          <SubSection
            object3d={nodes.hardline}
            isProductSection
            // hideModel={false}
            hideWhenActive={true}
          />
        </group>

        <MountWithEbbne mountedWhen={"active-and-below"}>
          <Suspense fallback={<LoadingCallback />}>
            <HardlineWrapper />
          </Suspense>
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="coilService" visibleWithAbove={2}>
        <group position={nodes.products.position} rotation={nodes.products.rotation}>
          <SubSection
            object3d={nodes.coilservices}
            isProductSection
            // hideModel={false}
            hideWhenActive={false}
          />

          <MountWithEbbne mountedWhen={"visible"}>
            <RoundedPlaneGeometry
              radius={0.1}
              lenght={2.6}
              width={8.14}
              // height={40}
              curveSegments={32}
              position={nodes.coilservices.position}
              // renderOrder={3}
            />
          </MountWithEbbne>
        </group>
      </Ebbne>
    </Ebbne>
  );
};

export default HeatingProducts;
